// Тема на приложението (светла/тъмна). Изборът е ЛИЧНА настройка на
// потребителя и живее в org базата (`user_configuration.theme`, идва с
// GET /user/info → configuration) — не в localStorage, за да е една и съща на всяко
// устройство; общият акаунт на терминала има своя, която важи на ПИН екрана.
// Прилага се като клас "dark" върху <html> — всички тъмни
// стойности в index.css са под селектора .dark, а antd минава на
// darkAlgorithm от ThemedConfig. Синхронизацията база → store е в
// components/UserConfigurationSync.tsx.
export type ThemeMode = "light" | "dark";

export function applyThemeMode(mode: ThemeMode): void {
  document.documentElement.classList.toggle("dark", mode === "dark");
}
